import { z } from "zod"

// PRD-04 (revised 2026-05-04) — name + email are both required for the
// single-add path (manual modal + onboarding manual row). The CSV importer
// has its own row-level validation and is unaffected. Mirrors the backend
// validation in api/students.py::create_student.
export const studentRowSchema = z.object({
  name: z.string().trim().min(1, "name_required"),
  email: z.string().trim().min(1, "email_required").email("invalid_email"),
  matricula: z.string().trim().optional().default(""),
})

export type StudentRowInput = z.infer<typeof studentRowSchema>
